<div class="main-page">
  <div class="flex justify-center">
    <nav class="w-full max-w-[1500px] max-[1520px]:px-24 py-2 mt-2 max-lg:px-8">
      <div
        class="contents-center items-center flex justify-between text-center"
      >
        <div class="hidden max-sm:block">
          <hugeicons-icon
            [icon]="icons.menu"
            [size]="24"
            color="currentColor"
            [strokeWidth]="2"
          ></hugeicons-icon>
        </div>
        <h1
          class="max-sm:hidden !text-3xl max-lg:!text-2xl max-lg:pt-3 max-md:!text-xl max-sm:!text-base"
        >
          Tanzania Standard Newspapers
        </h1>
        <div class="space-x-1 flex">
          <button class="flex gap-2">
            <hugeicons-icon
              [icon]="icons.bell"
              [size]="18"
              color="currentColor"
              [strokeWidth]="2"
            ></hugeicons-icon>
            Subscribe Now
          </button>
          <button class="outlined" [routerLink]="['/login']">Sign In</button>
        </div>
      </div>
    </nav>
  </div>
  <div
    class="bg-[#0f3e83] flex justify-center border-t-2 sticky border-yellow-500 max-sm:hidden"
  >
    <div
      class="flex justify-between w-full max-w-[1500px] max-[1520px]:px-24 text-white p-4 mt-2 max-lg:px-8"
    >
      <div class="">
        <hugeicons-icon
          [icon]="icons.menu"
          [size]="24"
          color="currentColor"
          [strokeWidth]="2"
        ></hugeicons-icon>
      </div>
      <ul class="gap-8">
        @for(menu of menus; track $index){
        <li class="text-lg font-semibold {{ $index == 0 ? 'highlight' : '' }}">
          <a href="">{{ menu.title }}</a>
        </li>
        }
      </ul>
    </div>
  </div>
  <div class="slideshow-container">
    <!-- Slide Body -->
    <div class="slide bg-gray-900 flex justify-center min-h-[90vh] relative" [class]="'slide ' + animationState"
      [class.is-advert]="slides[currentSlideIndex]?.isAdvert"
      [style.background-image]="!slides[currentSlideIndex]?.isAdvert ? 'url(' + slides[currentSlideIndex]?.backgroundImage + ')' : 'none'"
      [style.background-size]="'contain'" [style.background-repeat]="'no-repeat'"
      [style.background-position]="'center center'">

      <!-- Progress Bar -->
      <div class="slideshow-progress" *ngIf="isPlaying">
        <div class="progress-bar" [style.width]="progressWidth"></div>
      </div>

      <!-- Regular Content Overlay (with gradient) - NON-ADVERT -->
      <div *ngIf="!slides[currentSlideIndex]?.isAdvert"
        class="absolute top-0 left-0 w-full h-full flex items-center content-center justify-center text-white border-b-4 border-yellow-500"
        style="background: linear-gradient(to right, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.75) 100%);">
        <div class="w-full relative max-w-[1500px] max-[1520px]:px-24 max-lg:px-8">
          <!-- Title -->
          <h1 class="!text-5xl max-lg:!text-4xl slide-title drop-shadow-lg">
            <ng-container
              *ngIf="slides[currentSlideIndex]?.highlight && slides[currentSlideIndex]?.title?.includes(slides[currentSlideIndex]?.highlight); else simpleTitle">
              {{ slides[currentSlideIndex].title.split(slides[currentSlideIndex].highlight)[0] }}
              <span class="highlight text-yellow-400">{{ slides[currentSlideIndex].highlight }}</span>
              {{ slides[currentSlideIndex].title.split(slides[currentSlideIndex].highlight)[1] }}
            </ng-container>
            <ng-template #simpleTitle>
              {{ slides[currentSlideIndex]?.title }}
            </ng-template>
          </h1>
          <!-- Subtitle -->
          <p class="text-2xl max-lg:text-xl max-w-[1000px] pt-4 opacity-90 slide-subtitle drop-shadow-md">
            {{ slides[currentSlideIndex]?.subtitle }}
          </p>
        </div>
      </div>

      <!-- Advertisement Layout - SPLIT VIEW -->
      <div *ngIf="slides[currentSlideIndex]?.isAdvert"
        class="absolute top-0 left-0 w-full h-full flex items-center border-b-4 border-yellow-500">

        <div class="advert-layout w-full h-full flex max-lg:flex-col">
          <!-- Left Side - Text Content -->
          <div
            class="advert-text-section flex-1 flex items-center justify-center bg-gradient-to-r from-gray-900 via-gray-800 to-transparent p-12 max-lg:p-8">
            <div class="max-w-[600px]">


              <!-- Title -->
              <h1 class="!text-5xl max-lg:!text-4xl text-white slide-title drop-shadow-lg mb-4">
                <ng-container
                  *ngIf="slides[currentSlideIndex]?.highlight && slides[currentSlideIndex]?.title?.includes(slides[currentSlideIndex]?.highlight); else simpleTitle2">
                  {{ slides[currentSlideIndex].title.split(slides[currentSlideIndex].highlight)[0] }}
                  <span class="highlight text-yellow-400">{{ slides[currentSlideIndex].highlight }}</span>
                  {{ slides[currentSlideIndex].title.split(slides[currentSlideIndex].highlight)[1] }}
                </ng-container>
                <ng-template #simpleTitle2>
                  {{ slides[currentSlideIndex]?.title }}
                </ng-template>
              </h1>

              <!-- Subtitle -->
              <p class="text-2xl max-lg:text-xl text-white opacity-90 slide-subtitle drop-shadow-md leading-relaxed">
                {{ slides[currentSlideIndex]?.subtitle }}
              </p>
              <div style="height: 20px;">

              </div>
              <!-- Advertisement Badge -->
              <div class="mb-6 inline-block animate-pulse">
                <span class="bg-yellow-500 text-black px-5 py-2.5 rounded-full text-sm font-bold shadow-lg">
                  📢 Advertisement
                </span>
              </div>


            </div>
          </div>

          <!-- Right Side - Image -->
          <div class="advert-image-section flex-1 flex items-center justify-center p-8 max-lg:p-4">
            <div class="advert-image-container w-full h-full flex items-center justify-center">
              <img [src]="slides[currentSlideIndex]?.backgroundImage" [alt]="slides[currentSlideIndex]?.title"
                class="max-w-full max-h-full object-contain drop-shadow-2xl" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Controllers -->
    <div class="flex justify-end">
      <div class="relative bg-blue-950 p-4 py-4 flex gap-2 items-center content-center justify-center trapezoid pl-12">
        <!-- Slide Indicators -->
        <ul class="flex gap-2 text-white font-bold items-center content-center justify-center text-lg listed_list">
          <li *ngFor="let slide of slides; let i = index" [class.highlights]="i === currentSlideIndex"
            [attr.data-slide]="i" (click)="goToSlide(i)"
            class="cursor-pointer transition-all duration-300 hover:scale-110" [title]="slide?.title"></li>
        </ul>
        <!-- Play/Pause Button -->
        <button class="!bg-white slideshow-control hover:!bg-gray-100" (click)="togglePlayPause()"
          [attr.aria-label]="isPlaying ? 'Pause slideshow' : 'Play slideshow'">
          <hugeicons-icon [icon]="isPlaying ? icons.pause : icons.play" [size]="16" color="black"
            [strokeWidth]="3"></hugeicons-icon>
        </button>
        <!-- Previous Button -->
        <button class="!bg-white slideshow-control hover:!bg-gray-100" (click)="prevSlide()"
          aria-label="Previous slide">
          <hugeicons-icon [icon]="icons.arrowLeft" [size]="16" color="black" [strokeWidth]="3"></hugeicons-icon>
        </button>
        <!-- Next Button -->
        <button class="!bg-white slideshow-control hover:!bg-gray-100" (click)="nextSlide()" aria-label="Next slide">
          <hugeicons-icon [icon]="icons.arrowRight" [size]="16" color="black" [strokeWidth]="3"></hugeicons-icon>
        </button>
      </div>
    </div>
  </div>


  <app-today-trend-section></app-today-trend-section>
  
  <app-premium-stories></app-premium-stories>
  <app-report-trend-section></app-report-trend-section>
  <app-magazine-trend-section></app-magazine-trend-section>
  <app-book-trend-section></app-book-trend-section>

  <div class="mt-10">
    <app-footer></app-footer>
  </div>
</div>